import React from 'react';
import clsx from 'clsx';

import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';

import { UPLOAD_OPTIONS } from '@shared/constants';

import SuccessList from './success-list';
import ErrorList from './error-list';
import useStyle from './style';

const defaultState = {
  isErrorExpanded: true,
};
const paperElevation = 1;

const UploadProgress = ({
  action = UPLOAD_OPTIONS.CREATE_OR_UPDATE_RULE,
  label = 'REMAINING',
  remainingItem = 0,
  totalItem = 0,
  isRateLimited = false,
  rateLimitDelay = 0,
  errorList = [],
  successList = [],
  countData = [],
}) => {
  const classes = useStyle();
  const [state, setState] = React.useState(defaultState);

  return (
    <Paper
      className={clsx(
        'd-flex f-justify-center flex-column mr-10 ml-10 p-6 mt-5'
      )}
      elevation={paperElevation}
    >
      <Typography variant='h6' className='d-flex f-justify-center text-bold'>
        {`${remainingItem} ${label}`}
      </Typography>
      <LinearProgress
        classes={{
          barColorPrimary: errorList.length
            ? classes.errorColor
            : classes.successColor,
        }}
        className={clsx(classes.progressBar, 'w-100 mt-2')}
        variant='determinate'
        value={((totalItem - remainingItem) / totalItem) * 100}
      />
      {isRateLimited && (
        <div className='d-flex f-align-center f-justify-center mt-4'>
          <Chip
            label={`Oops! Rate limit exceeded. Upload will resume in ${rateLimitDelay ||
              '60'} seconds.`}
            color='primary'
            className='mr-4 mt-2 mb-2 bg-danger color-white'
          />
        </div>
      )}
      <Typography
        variant='body2'
        className='d-flex f-justify-start w-100 color-text-secondary mt-1'
      >
        {Math.floor(((totalItem - remainingItem) / totalItem) * 100)}%
      </Typography>
      {!!errorList.length && (
        <ErrorList
          isExpanded={state.isErrorExpanded}
          onToggleIcon={() => {
            setState(prevState => ({
              ...prevState,
              isErrorExpanded: !prevState.isErrorExpanded,
            }));
          }}
          errorList={errorList}
        />
      )}
      {(!!successList.length || !!countData.length) && (
        <SuccessList
          action={action}
          successList={successList}
          countData={countData}
        />
      )}
    </Paper>
  );
};

export default UploadProgress;
